import { useWidgetContent } from "./Content064.context";
import { DefaultBlock } from "./DefaultBlock";
import { GridBlock } from "./GridBlock";

export const BlockType = () => {
  const { selectedCourses } = useWidgetContent();

  return selectedCourses.length === 0 ? <DefaultBlock /> : <GridBlock />;
};
